import { buildCurrentUnderstandingFull, getUserConditions } from "../self-assesment2/generatePayloadForScreen";

/* eslint-disable no-unused-vars */
const subDomain = (window.location.host === "www.startfreept.com" ||
    window.location.host === "startfreept.com" ||
    window.location.host === "virdiohealth.com" ||
    window.location.host === "www.virdiohealth.com")
    ? "api" : "uatapi";

const CHAT_API_URL = `https://${subDomain}.virdiohealth.com/api/v1/assessment/chat`;

const MyraChatService = {
    /**
     * Send a user message and get Myra's response.
     * @param {string} userMessage - The text the user typed
     * @param {string} sessionId - The analytics session ID (window.trSessionId)
     * @param {Array} conversationHistory - Array of {role, content} objects for context
     * @param {number} turnNumber - The current turn number in the conversation
     * @returns {Promise<{response: string, conversationHistory: Array}>}
     */
    sendMessage: async (userMessage, sessionId, conversationHistory = [], turnNumber, screenPayload = {}, screenName = "") => {
        const flow = window.currentFlow || window.VoiceService._currentFlow || "unknown_flow"
        let symptomType = false;
        let romChange = "";
        let tempoChange = "";
        let data_source = "";
        let whats_next = "";
        let rpe = 0;
        let painLocations = []
        let symptomDuration = ""
        let preTestNPRS = 0
        const userName = window.localStorage.getItem("self_name") || ""
        if (window?.flowSymptomPayload) {
            symptomType = window?.flowSymptomPayload?.symptomType;
            romChange = window?.flowSymptomPayload?.romChange;
            tempoChange = window?.flowSymptomPayload?.tempoChange;
            data_source = window?.flowSymptomPayload?.data_source;
            whats_next = window?.flowSymptomPayload?.whats_next;
            preTestNPRS = window?.flowSymptomPayload?.preTestNPRS;
            symptomDuration = window?.flowSymptomPayload?.symptomDuration;
            rpe = window?.flowSymptomPayload?.rpe;
            painLocations = window?.flowSymptomPayload?.painLocations;
        }
        try {
            const gsaStep = screenPayload?.gsa_step || screenName;
            const assessmentData = localStorage.getItem("assessmentData") ? JSON.parse(localStorage.getItem("assessmentData")) : {};
            const payload = {
                session_id: sessionId,
                message: userMessage,
                conversation_history: conversationHistory,
                turnNumber: turnNumber || 0,
                source: gsaStep,
                timestamp: new Date().toISOString(),
                screenPayload: screenPayload,
                flow: flow,
                userName: userName,
                input_mode: window?.MyraInteraction?.getMode() || 'button',
                ...(flow === "flow_symptom" && {
                    symptomType,
                    romChange,
                    tempoChange,
                    whats_next,
                    data_source,
                    preTestNPRS,
                    symptomDuration,
                    rpe,
                    painLocations,
                    current_understanding: buildCurrentUnderstandingFull(assessmentData),
                    user_conditions: getUserConditions(),
                })
            };
            console.log("Sending chat payload:", payload);

            const response = await fetch(CHAT_API_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });



            const data = await response.json();
            console.log("Received chat response:", data);
            const action = data?.data?.action || data?.action || null;
            let value = data?.data?.value || data?.value || null;
            // const speech = data?.response || "";
            const intent = data?.data?.intent || data?.intent || null;
            const moveAction = data?.MoveAction || null;
            const extracted = data?.data?.extracted || data?.extracted || null;
            const speech = data?.data?.speech || data?.speech || "";
            const actions = data?.data?.actions || data?.actions || null;
            let actionValue = data?.data?.actionValue || data?.actionValue || null;
            const matched = data?.data?.matched || data?.matched || null;

            if (window.MyraInteraction.getCurrentScreen() === "nprs_symptoms") {
                if (action === "SELECT_PAIN_LEVEL" && moveAction === true && !value && !actionValue && matched === "classifier") {
                    value = 0
                    actionValue = 0
                }
            }

            window._lastCommandAction = action;
            if (action && window.currentCommandsAudio?.[action]) {
                const now = Date.now();
                if (now - (MyraChatService._lastCallTime || 0) > 500) {
                    console.log(`[CHAT] Executing command handler: ${action}`);
                    window.currentCommandsAudio[action](value, speech, intent, extracted, actionValue, actions, matched);
                    MyraChatService._lastCallTime = now;
                } else {
                    console.log('[CHAT] Too fast call, skipping');
                }
            }
            if (window.MyraInteraction.getCurrentScreen() === "intro") {
                window.landingHistory = data.history || []
            }
            return {
                response: data.response,
                moveAction: moveAction ? true : false,
                action: action,
                actions: actions,
                actionValue: actionValue,
                matched: matched,
                value: data.value,
                speech: speech,
                conversationHistory: data.history,
                intent: data.intent || null,
                extracted: extracted,
                conditions: data.conditions || null,
                turnNumber: data.turnNumber || 0,
                history: data.history || []
            };
        } catch (error) {
            console.error("MyraChatService.sendMessage Error:", error);
            return {
                response: "I'm having trouble connecting right now. You can try again, or tap the mic to talk to me instead.",
                conversationHistory,
            };
        }
    },
};

export default MyraChatService;